import { render, staticRenderFns } from "./ReservationTool.vue?vue&type=template&id=20063a98&scoped=true"
import script from "./ReservationTool.vue?vue&type=script&lang=js"
export * from "./ReservationTool.vue?vue&type=script&lang=js"
import style0 from "./ReservationTool.vue?vue&type=style&index=0&id=20063a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20063a98",
  null
  
)

export default component.exports